// extracted by mini-css-extract-plugin
module.exports = {"spinner":"funLoading_spinner__VoK0X","spin":"funLoading_spin__K8Lgq","spinner-inner":"funLoading_spinner-inner___EG1N"};